import type { SerializedStyles } from "@emotion/react";
import { css, useTheme } from "@emotion/react";
import type { Padding, SizeName } from "@towni/common";
import { sizeNameMap } from "@towni/common";
import type * as React from "react";
import { paddingToCssValue } from "./padding";

type Props = {
    readonly display?: "block" | "inline";
    readonly size?: SizeName;
    readonly weight?:
        | "100"
        | "200"
        | "300"
        | "400"
        | "500"
        | "600"
        | "700"
        | "800"
        | "900"
        | "bold";
    readonly padding?: Padding;
    readonly color?: string;
    readonly cursor?: "auto" | "pointer";
    readonly notSelectable?: boolean;
    readonly onClick?: () => void;
    readonly styling?: SerializedStyles;
    readonly children: React.ReactNode;
};

const Box = (props: Props) => {
    const theme = useTheme();
    if (!props.children) return <></>;

    const { display, color, size, weight, padding, cursor, notSelectable } =
        props;

    const styling = css`
        display: ${display || "inline"};
        ${display === "block" ? "white-space: nowrap;" : ""}
        font-size: ${theme.sizes.inRem[size || sizeNameMap.M]}rem;
        ${(padding && `padding:${paddingToCssValue(padding)};`) || ""}
        ${(weight && `font-weight:${weight};`) || ""}
        ${(color && `color:${color};`) || ""}
        ${(cursor && `cursor:${cursor};`) || ""}
        ${(notSelectable && `user-select: none;`) || ""}
        
        ${(props.styling && props.styling) || ""}
    `;

    return (
        <div css={styling} onClick={props.onClick}>
            {props.children}
        </div>
    );
};

export { Box };
